import { useEffect as useNoIndexEffect } from "react";

import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CTASection } from "@/components/CTASection";
import { SectionTitle } from "@/components/SectionTitle";
import { Helmet } from "react-helmet";
import { Button } from "@/components/ui/button";
import { DentalPlanCard } from "@/components/DentalPlanCard";
import { TreatmentServiceCard } from "@/components/TreatmentServiceCard";
import { BenefitCard } from "@/components/BenefitCard";
import { PatientTestimonialCard } from "@/components/PatientTestimonialCard";
import { Phone, Calendar, Check, ShieldCheck, Star, Wrench } from "lucide-react";
import { FAQAccordion } from "@/components/FAQAccordion";

const DentalAds = () => {
  useNoIndexEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots"; m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => { m.remove(); };
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBookAppointment = () => {
    window.open("https://www.healthcoco.com/nagpur/doctor/dr-hemant-asrani-endodontist-dentist/USRH249D644", "_blank");
  };

  return (
    <>
      <Helmet>
        <title>Special Dental Offers & Plans | Asrani Dental Clinic Nagpur</title>
        <meta name="description" content="Exclusive dental offers at Asrani Dental Clinic. Save on treatments with our dental health plans, EMI options, and special packages. Book now!" />
        <meta name="keywords" content="dental offers, dental plans, dental packages, affordable dentistry, dental treatment offers, Asrani Dental Clinic, Nagpur dentist" />
        <link rel="canonical" href="https://asranidental.com/dental-ads" />
        <meta property="og:title" content="Special Dental Offers & Plans | Asrani Dental Clinic Nagpur" />
        <meta property="og:description" content="Exclusive dental offers at Asrani Dental Clinic. Save on treatments with our dental health plans, EMI options, and special packages." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://asranidental.com/dental-ads" />
        <meta property="og:image" content="/lovable-uploads/8ac72d70-a3d2-477b-af4a-21d4927e27a1.png" />
      </Helmet>

      <Header />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 bg-gradient-to-br from-dental-accent/10 to-dental-cream">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="animate-fade-in">
              <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-serif font-semibold mb-6 leading-tight text-dental-text">
                All Dental Treatments <span className="text-dental-highlight">UNDER ONE ROOF!</span>
              </h1>
              <p className="text-lg md:text-xl text-dental-muted mb-8">
                Experience comprehensive dental care with special packages and no-cost EMI options. Quality treatments at affordable prices.
              </p>
              
              <div className="flex flex-wrap gap-4 mb-8">
                <div className="bg-white px-4 py-3 rounded-full flex items-center shadow-sm">
                  <span className="w-8 h-8 rounded-full bg-dental-highlight/10 flex items-center justify-center mr-2">
                    <Check size={16} className="text-dental-highlight" />
                  </span>
                  <span className="text-dental-text font-medium">RCT</span>
                </div>
                
                <div className="bg-white px-4 py-3 rounded-full flex items-center shadow-sm">
                  <span className="w-8 h-8 rounded-full bg-dental-highlight/10 flex items-center justify-center mr-2">
                    <Check size={16} className="text-dental-highlight" />
                  </span>
                  <span className="text-dental-text font-medium">Laser</span>
                </div>
                
                <div className="bg-white px-4 py-3 rounded-full flex items-center shadow-sm">
                  <span className="w-8 h-8 rounded-full bg-dental-highlight/10 flex items-center justify-center mr-2">
                    <Check size={16} className="text-dental-highlight" />
                  </span>
                  <span className="text-dental-text font-medium">Extractions</span>
                </div>
                
                <div className="bg-white px-4 py-3 rounded-full flex items-center shadow-sm">
                  <span className="w-8 h-8 rounded-full bg-dental-highlight/10 flex items-center justify-center mr-2">
                    <Check size={16} className="text-dental-highlight" />
                  </span>
                  <span className="text-dental-text font-medium">Crowns</span>
                </div>
              </div>
              
              <div className="bg-dental-highlight/10 p-4 rounded-lg mb-8 border border-dental-highlight/20">
                <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                  <div className="flex-1">
                    <p className="font-medium text-dental-text">NO COST EMI</p>
                    <p className="text-dental-muted text-sm">Available across all clinics</p>
                  </div>
                  <div className="flex-shrink-0">
                    <span className="inline-block bg-dental-highlight text-white px-4 py-2 rounded-lg font-medium">
                      UPTO 20% OFF*
                    </span>
                  </div>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <Button 
                  onClick={handleBookAppointment}
                  className="btn-primary flex items-center gap-2 py-6"
                >
                  <Calendar size={18} />
                  Book Appointment
                </Button>
                
                <a onClick={(e) => { e.preventDefault(); (window as any).gtag_report_conversion && (window as any).gtag_report_conversion("tel:+918010224989"); }} href="tel:+918010224989" 
                  className="bg-white text-dental-highlight border border-dental-highlight hover:bg-dental-highlight hover:text-white transition-colors duration-300 px-6 py-3 rounded-md font-medium flex items-center justify-center gap-2"
                >
                  <Phone size={18} />
                  Call Now
                </a>
              </div>
            </div>
            
            <div className="animate-fade-in relative order-first lg:order-last">
              <img 
                src="/lovable-uploads/efdb41d1-0ab8-4227-902b-10b6a3b129af.png" 
                alt="Dental treatments at Asrani Dental Clinic" 
                className="rounded-xl shadow-lg w-full"
              />
              <div className="absolute -bottom-5 -left-5 bg-white rounded-lg shadow-lg p-3 hidden md:block">
                <div className="flex items-center gap-2">
                  <div className="flex">
                    {[1, 2, 3, 4, 5].map((_, i) => (
                      <Star key={i} size={16} fill="#FFD700" color="#FFD700" />
                    ))}
                  </div>
                  <span className="font-medium text-sm">5.0/5 Rating</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Dental Plans Section */}
      <section className="py-16 md:py-24 bg-dental-offwhite">
        <div className="container-custom">
          <SectionTitle 
            subtitle="EXCLUSIVE OFFERS"
            title="Asrani Dental Health Plans"
            description="Choose from our curated dental health plans designed to provide comprehensive care at affordable prices."
            alignment="center"
          />
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
            <DentalPlanCard 
              title="Basic Dental Health Plan"
              originalPrice="₹1500"
              discountedPrice="₹999"
              features={[
                "Complete Dental Check-up",
                "Scaling & Polishing",
                "Fluoride Application",
                "Dental X-rays (2)",
                "Treatment Plan"
              ]}
              recommended={false}
              image="/lovable-uploads/ca888950-cd21-4651-af91-c5ad93a14833.png"
            />
            
            <DentalPlanCard 
              title="Advanced Dental Health Plan"
              originalPrice="₹3000"
              discountedPrice="₹1999"
              features={[
                "Everything in Basic Plan",
                "Deep Cleaning",
                "Cavity Detection",
                "Tooth Sensitivity Treatment",
                "Emergency Consultation (3 months)"
              ]}
              recommended={true}
              image="/lovable-uploads/7c523b12-a0a7-4c42-a923-44d4e4aa3900.png"
            />
            
            <DentalPlanCard 
              title="Complete Dental Care Package"
              originalPrice="₹5000"
              discountedPrice="₹3499"
              features={[
                "Everything in Advanced Plan",
                "Family Dental Check-up (3 members)",
                "Teeth Whitening Session",
                "Smile Design Consultation",
                "Priority Appointments (6 months)"
              ]}
              recommended={false}
              image="/lovable-uploads/29a6ae96-1721-44fd-9f48-207235e5376b.png"
            />
          </div>
        </div>
      </section>
      
      {/* Treatment Services Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container-custom">
          <SectionTitle 
            subtitle="OUR SPECIALTIES"
            title="Key Treatment Services"
            description="Top treatments for a healthier smile from our experienced dental professionals."
            alignment="center"
          />
          
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6 lg:gap-8 mb-12">
            <TreatmentServiceCard 
              title="Dental Implants"
              imageUrl="/lovable-uploads/f0524047-c9dd-4b15-944b-09c88dfe7559.png"
              link="/services#dental-implants"
            />
            
            <TreatmentServiceCard 
              title="Invisalign & Aligners"
              imageUrl="/lovable-uploads/ae221424-ee6c-4261-ad8c-21e625d8b9de.png"
              link="/services#orthodontics"
            />
            
            <TreatmentServiceCard 
              title="Full Mouth Rehabilitation"
              imageUrl="/lovable-uploads/c95ed979-9523-4aa6-a442-ef6230e9491c.png"
              link="/services#full-mouth-rehabilitation"
            />
            
            <TreatmentServiceCard 
              title="Smile Makeover"
              imageUrl="/lovable-uploads/23447402-10d9-4778-b0d2-2e53432a55e2.png"
              link="/services#cosmetic-dentistry"
            />
            
            <TreatmentServiceCard 
              title="Root Canal Treatment"
              imageUrl="/lovable-uploads/5e3d1f06-e1ad-401c-904d-d605ec2dc0cd.png"
              link="/services#root-canal-treatment"
            />
            
            <TreatmentServiceCard 
              title="Crowns & Bridges"
              imageUrl="/lovable-uploads/205f1536-264e-4611-a9db-1c1cafe2d121.png"
              link="/services#restorative-dentistry"
            />
          </div>
          
          <div className="bg-dental-highlight/10 p-6 md:p-8 rounded-xl mb-12">
            <div className="flex flex-col sm:flex-row sm:items-center gap-6">
              <div className="flex-1">
                <h3 className="text-xl md:text-2xl font-serif font-medium mb-2">NO COST EMI</h3>
                <p className="text-dental-muted">Available across all clinics. Spread your payments with easy monthly installments.</p>
              </div>
              <div className="flex-shrink-0">
                <span className="inline-block bg-dental-highlight text-white px-6 py-3 rounded-lg font-medium text-lg">
                  UPTO 20% OFF*
                </span>
              </div>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            <img 
              src="/lovable-uploads/9678e02c-fd40-4ceb-beeb-1f33d01e6857.png" 
              alt="Dental clinic treatment room at Asrani Dental" 
              className="rounded-xl shadow-md object-cover h-64 w-full"
            />
            <img 
              src="/lovable-uploads/736ba118-e18e-40da-9c2c-7ee285e43fbb.png" 
              alt="State-of-the-art dental equipment at Asrani Dental" 
              className="rounded-xl shadow-md object-cover h-64 w-full"
            />
          </div>
        </div>
      </section>
      
      {/* Why Choose Us Section */}
      <section className="py-16 md:py-24 bg-dental-cream">
        <div className="container-custom">
          <SectionTitle 
            subtitle="WHY CHOOSE US"
            title="Why Trust Asrani Dental"
            description="We combine expertise with compassionate care to deliver outstanding dental services."
            alignment="center"
          />
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            <BenefitCard 
              title="25+ Years of Experience"
              description="Our team brings decades of specialized expertise to every patient." 
              icon={<Star size={24} className="text-dental-highlight" />}
            />
            
            <BenefitCard 
              title="15,000+ Happy Patients"
              description="Thousands of satisfied patients trust us with their dental health."
              icon={<img src="/lovable-uploads/a8dde84d-dc06-401a-b0d9-f466999fd073.png" alt="Happy Patients" className="w-6 h-6 object-contain" />}
            />
            
            <BenefitCard 
              title="Modern Equipment"
              description="State-of-the-art technology for precise diagnosis and treatment."
              icon={<Wrench size={24} className="text-dental-highlight" />}
            />
            
            <BenefitCard 
              title="Honest Guidance"
              description="Transparent treatment plans and pricing without hidden costs."
              icon={<ShieldCheck size={24} className="text-dental-highlight" />}
            />
          </div>
        </div>
      </section>
      
      {/* Patient Testimonials Section */}
      <section className="py-16 md:py-24 bg-[#221F26] text-white">
        <div className="container-custom">
          <div className="mb-12 max-w-3xl mx-auto text-center">
            <span className="block text-dental-highlight font-medium mb-2 uppercase tracking-wider text-sm">
              PATIENT SPEAK
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold mb-4 text-white">
              What Our Patients Say
            </h2>
            <p className="text-white/80 text-lg">
              Read about real experiences from our satisfied patients who have transformed their smiles with us.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
            <PatientTestimonialCard 
              name="Sakshi Sharma"
              content="I visited Dr. Asrani for my root canal treatment. The procedure was painless and professional. Thank you for making my dental experience so comfortable."
              rating={5}
            />
            
            <PatientTestimonialCard 
              name="Sanjay Kumar"
              content="Had severe dental anxiety before coming here. The staff was extremely patient and understanding. My implant procedure went smoothly and I couldn't be happier with the results!"
              rating={5}
            />
            
            <PatientTestimonialCard 
              name="Priyanka Mehta"
              content="Incredible service! Dr. Asrani completely transformed my smile with cosmetic treatments. The attention to detail and care provided by the entire team was outstanding."
              rating={5}
            />
          </div>
        </div>
      </section>
      
      {/* Safety Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container-custom">
          <SectionTitle 
            subtitle="SAFETY FIRST"
            title="Your Safety is Our Priority"
            description="Strict safety protocols for your peace of mind during every visit."
            alignment="center"
          />
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            <div className="bg-dental-cream rounded-xl overflow-hidden">
              <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="p-6">
                  <h3 className="text-xl font-serif font-medium mb-3 relative inline-block">
                    Clinic Safety
                    <span className="absolute -bottom-1 left-0 right-0 h-1 bg-dental-highlight"></span>
                  </h3>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <Check size={18} className="text-dental-highlight mt-1 mr-2 flex-shrink-0" />
                      <span>Sterilized Equipment & Instruments</span>
                    </li>
                    <li className="flex items-start">
                      <Check size={18} className="text-dental-highlight mt-1 mr-2 flex-shrink-0" />
                      <span>Regular Sanitization of All Facility Areas</span>
                    </li>
                    <li className="flex items-start">
                      <Check size={18} className="text-dental-highlight mt-1 mr-2 flex-shrink-0" />
                      <span>COVID-19 Safety Protocols Followed</span>
                    </li>
                    <li className="flex items-start">
                      <Check size={18} className="text-dental-highlight mt-1 mr-2 flex-shrink-0" />
                      <span>Social Distancing in Waiting Areas</span>
                    </li>
                  </ul>
                </div>
                
                <div className="bg-[#221F26]">
                  <img 
                    src="/lovable-uploads/9f14a73e-7e6b-4046-bf0c-449630e7de4b.png" 
                    alt="Safety protocols at Asrani Dental Clinic" 
                    className="w-full h-full object-cover opacity-80"
                  />
                </div>
              </div>
            </div>
            
            <div className="bg-dental-cream rounded-xl overflow-hidden">
              <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="p-6">
                  <h3 className="text-xl font-serif font-medium mb-3 relative inline-block">
                    Medical-Grade PPE
                    <span className="absolute -bottom-1 left-0 right-0 h-1 bg-dental-highlight"></span>
                  </h3>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <Check size={18} className="text-dental-highlight mt-1 mr-2 flex-shrink-0" />
                      <span>N95 Masks for All Staff Members</span>
                    </li>
                    <li className="flex items-start">
                      <Check size={18} className="text-dental-highlight mt-1 mr-2 flex-shrink-0" />
                      <span>Face Shields During Procedures</span>
                    </li>
                    <li className="flex items-start">
                      <Check size={18} className="text-dental-highlight mt-1 mr-2 flex-shrink-0" />
                      <span>Disposable Gloves Changed Between Patients</span>
                    </li>
                    <li className="flex items-start">
                      <Check size={18} className="text-dental-highlight mt-1 mr-2 flex-shrink-0" />
                      <span>Protective Barriers for Safety</span>
                    </li>
                  </ul>
                </div>
                
                <div className="bg-[#221F26]">
                  <img 
                    src="/lovable-uploads/ea53b3f4-0e40-4dfb-aa37-528888ab3037.png" 
                    alt="Medical-grade PPE at Asrani Dental Clinic" 
                    className="w-full h-full object-cover opacity-80"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* FAQ Section */}
      <section className="py-16 md:py-24 bg-dental-offwhite">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
            <div className="lg:col-span-2">
              <h2 className="text-3xl md:text-4xl font-serif font-semibold text-dental-text mb-6">
                Frequently<br />Asked<br /><span className="text-dental-highlight">Questions</span>
              </h2>
              <p className="text-dental-muted mb-8">
                Find answers to the most common questions about our dental treatments, plans, and policies.
              </p>
              <img 
                src="/lovable-uploads/762aed2d-c93c-4143-bd1e-b77314abdd09.png" 
                alt="Dr. Hemant Asrani" 
                className="rounded-xl shadow-md lg:max-w-sm"
              />
            </div>
            
            <div className="lg:col-span-3">
              <FAQAccordion 
                faqs={[
                  {
                    question: "How do I book an appointment?",
                    answer: "You can book an appointment by calling us at +91 8010224989, visiting our clinic, or booking online through our website or HealthCoco platform."
                  },
                  {
                    question: "Are dental treatments painful?",
                    answer: "We use modern techniques and anesthetics to ensure most treatments are painless. Our team is trained to provide comfortable care even for anxious patients."
                  },
                  {
                    question: "How often should I visit a dentist?",
                    answer: "We recommend a check-up every 6 months for most patients. However, this may vary based on your specific dental health needs."
                  },
                  {
                    question: "What payment options do you offer?",
                    answer: "We accept cash, all major credit/debit cards, and offer no-cost EMI options for most treatments. We also work with several insurance providers."
                  },
                  {
                    question: "How long do dental implants last?",
                    answer: "With proper care and maintenance, dental implants can last a lifetime. Regular check-ups and good oral hygiene are essential for longevity."
                  },
                  {
                    question: "Do you offer emergency dental services?",
                    answer: "Yes, we provide emergency dental care. Please call our emergency number if you're experiencing severe pain, swelling, or dental trauma."
                  }
                ]}
              />
            </div>
          </div>
        </div>
      </section>

      <CTASection 
        title="Ready to Transform Your Smile?"
        description="Book an appointment today and take advantage of our special offers and dental health plans."
        primaryButtonText="Book Appointment"
        secondaryButtonText="Contact Us"
      />
      
      <Footer />
    </>
  );
};

export default DentalAds;
